import React from 'react';
import BookInfoForm from 'component/admin/bookInfoForm';
import Swal from 'sweetalert2';
import { addBook } from 'services/admin/bookService';
import { useState } from 'react';
import { PacmanLoader } from 'react-spinners';

const AddBook = () => {
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem("token")
    const handleAddBook = async (formData) => {
        setIsLoading(true)
        try {
            const response = await addBook(token, formData)
            if (response.data.message === "Book has been created!") {
                Swal.fire({
                    title: "Thêm thành công!",
                    text: `Sách của bạn đã được thêm!.`,
                    icon: "success"
                });
            }
            else {
                Swal.fire({
                    title: "Lỗi!",
                    text: `Thêm sách không thành công!.`,
                    icon: "error"
                });
            }
            
        } 
        catch (error) {
            console.log("Add book: ", error)
            Swal.fire({
                title: "Lỗi!",
                text: `Thêm sách không thành công!.`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <BookInfoForm onSubmit={handleAddBook} />
            
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default AddBook;